var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"specs-list-component list-group list-group-flush"},_vm._l((_vm.specs),function({ title, tooltipText, subSpecs },index){return _c('li',{key:index,staticClass:"list-group-item",class:index},[_c('Spec',{attrs:{"title":title,"tooltip-text":tooltipText,"sub-specs":subSpecs}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }